import React from 'react';

export const builtItem = (navImage, code, navIcon, text) => {
  if (navImage) {
    return (
      <span className="section-nav nav-image">
        <img alt={code} src={navImage} />
      </span>
    );
  }
  if (navIcon) {
    return (
      <span className="section-nav">
        <img alt={code} src={navIcon} className="nav-icon" />
        {text}
      </span>
    );
  }
  return <span className="section-nav">{text}</span>;
};
